// How many images one order may contain, and why the number is what it is.
//
// Two separate ceilings sit downstream, and 20 clears both with margin:
//
// 1. Stripe (retail checkout). The Checkout Session carries every item's data
//    in its metadata, which allows a maximum of 50 keys. Item data is chunked
//    across additionalItems_N / additionalDiskFilenames_N keys, so the key
//    count climbs with cart size and sessions.create is rejected outright once
//    it passes 50 — the customer just sees "Failed to create checkout
//    session". Where that lands moves with filename length, whether
//    background removal set a spot-TIF path, and whether files upload or go by
//    reference: measured against the real chunking code it falls between 25
//    and 30 images, and it was 9 before the chunking fix (commit dbd5756).
//
// 2. multer (both flows). The upload parser accepts a bounded number of files
//    per request and discards the whole request past it — after every byte has
//    been uploaded. See MAX_IMAGES_PER_ORDER in production-server.js.
//
// Neither ceiling announces itself before it is hit, and neither is stable
// enough to sail close to, so the cap is enforced up front instead: in the
// cart, at checkout, and again on the server. Keep this in step with
// MAX_IMAGES_PER_ORDER in production-server.js.
export const MAX_IMAGES_PER_ORDER = 20;

// Shown when an add is refused. States the cap, gives the two ways forward
// (swap one out, or split into a second order), and ends with a human to
// email — without promising we'll place the order for them.
export const LIMIT_REACHED_MESSAGE =
  `You've reached the limit of ${MAX_IMAGES_PER_ORDER} images for one order, so no more can be added.\n\n` +
  'To use a different image, remove one from your cart first. To print more ' +
  `than ${MAX_IMAGES_PER_ORDER}, place this order and then start another.\n\n` +
  'Questions? Email us at support@presspeels.com.';

// Same situation reached from the other end: a cart that was already over the
// cap before this check existed. It persists in IndexedDB for 24 hours, so an
// oversized one outlives the deploy that capped it. Checkout has to refuse it
// too, and say exactly how many images have to go.
export const cartOversizeMessage = (count) => {
  const excess = count - MAX_IMAGES_PER_ORDER;
  return (
    `Your cart has ${count} images, and one order can include at most ` +
    `${MAX_IMAGES_PER_ORDER}.\n\n` +
    `Please remove ${excess} image${excess === 1 ? '' : 's'} and try again. ` +
    'The rest can go on a second order.\n\n' +
    'Questions? Email us at support@presspeels.com.'
  );
};
